<div class="row">
  <div class="secondary-details col-sm-6 my-2">
    <span>
      {{ 'mapping.specifications.shipmentSpecificationList.shipmentSpecification' | translate }}
    </span>
  </div>
  <div class="col-sm-6 text-end">
    <button
      class="me-1 icon-mat"
      (click)="createSpecification()"
      #tooltip="matTooltip"
      matTooltip="{{
        'mapping.specifications.shipmentSpecificationList.createSpecification' | translate
      }}"
      mat-raised-button>
      <em class="bi bi-plus"></em>
    </button>

    <button
      class="me-1 icon-mat"
      (click)="openUploadSpecification()"
      #tooltip="matTooltip"
      matTooltip="{{
        'mapping.specifications.shipmentSpecificationList.uploadSpecification' | translate
      }}"
      mat-raised-button>
      <em class="bi bi-upload"></em>
    </button>
  </div>
</div>

<div class="row py-2 sub-action">
  <div class="col-sm-6 search-bar-group">
    <input
      matInput
      [(ngModel)]="searchTerm"
      (keyup)="searchSpecification(searchTerm)"
      placeholder="{{
        'mapping.specifications.shipmentSpecificationList.searchSpecification' | translate
      }}" />
  </div>

  <div class="col-sm-6 text-end">
    <button
      *ngIf="showDeleteButton"
      class="icon-mat"
      (click)="deleteSpecification()"
      [matBadge]="specDeletionList?.length"
      matBadgeOverlap="true"
      matBadgeSize="small"
      matTooltip="{{
        'mapping.specifications.shipmentSpecificationList.uploadSpecification'
          | translate : { value: specDeletionList?.length }
      }}"
      mat-raised-button>
      <i class="bi bi-trash"></i>
    </button>
  </div>
</div>

<div class="spec-table-container py-2">
  <app-shipment-specification-table
    [searchTerm]="searchTermValue"
    (downloadSpec)="downloadTemplateExcel($event)"
    (editSpecEvent)="editSpecEvent($event)">
  </app-shipment-specification-table>
</div>
